<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t(integratType + 'Orders'))"
      icon="mdi-cart-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="($store.state.permissions && $store.state.permissions.includes(type)) ? $t('new') : ''"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        ref="refExcel"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <template #bulk>
      <button
        v-if="$store.state.permissions && $store.state.permissions.includes('remove' + type[0].toUpperCase() + type.substring(1))"
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <template #top>
<v-row class="mx-0 mb-2">
      <v-col
        class=" px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          solo
          flat
          clearable
          height="30"
          :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
          dense
        />
      </v-col>
    </v-row>
      </template>
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile"
        :footer-props="plFooterProps"
      >
        <template
          v-if="isMobile"
          v-slot:item="{ item, index }"
        >
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0 "
                :class="{
                  'mobile-td-list-border-green': (item.type == 'sell' || item.type == 'presale'? true : false ),
                  'mobile-td-list-border-red': (item.type == 'purchase' ? true : false ),
                  'mobile-td-list-border-primary': (item.type == 'returnSell' || item.type == 'returnPurchase' ? true : false ),
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="print(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="fishPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-paper-roll-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceRollprint')" />
                        </v-list-item>
                        <v-list-item
                          v-if="type == 'sell'"
                          link
                          @click="invoiceSms(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-message-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('sendInvoiceSMS')" />
                        </v-list-item>
                        <v-list-item
                          v-if="item.entrepot"
                          link
                          @click="entrepotPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-warehouse</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="copyInvoice(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-content-copy</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceCopy')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/' + type +'/edit/' + item.uid"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission(type)"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ (item.customer ? item.customer.name : '') }} ({{ item.number }})
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('document-number') }} : {{ item.doc_header.number }}
                    | {{ $t('id') }} : {{ item.id }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('discount') }} : {{ $numberFormat((item.discount ? item.discount : 0)) }}
                    | {{ $t('tax') }} : {{ $numberFormat((item.tax ? item.tax : 0)) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('date') }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-for="(integrate, index) in item.integrator"
                        :key="index"
                        color="green"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ $t('registerBy') }} : {{ $t(integrate.key) }}  | {{ $t('id') }} : {{ integrate.value }}
                          {{ (integrate.number ? ' | ' + $t('number') + ':' + integrate.number : '' ) }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-if="item.payed"
                        class="ms-1"
                        :color="(parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? 'red' : 'green')"
                        small
                        outlined
                      >
                        {{ (parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.price.price)-parseFloat(item.payed.amount)) : $t('payed')) }}
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn
                    dark
                    text
                    small
                    color="primary"
                    @click="edit(item)"
                  >
                    {{ $numberFormat((item.price ? item.price.NetPrice : 0)) }} {{ item.currency.symbol }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                class="pl-action-cell__btn" icon x-small
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-show="type == 'sell' || type == 'presale'"
                link
                @click="editCategory(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('editCasher')" />
              </v-list-item>
              <v-list-item
                link
                @click="print(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                link
                @click="fishPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-paper-roll-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceRollprint')" />
              </v-list-item>
              <v-list-item
                v-if="type == 'sell'"
                link
                @click="invoiceSms(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-message-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('sendInvoiceSMS')" />
              </v-list-item>
              <v-list-item
                v-if="item.entrepot"
                link
                @click="entrepotPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-warehouse</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
              </v-list-item>
              <v-list-item
                link
                @click="copyInvoice(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceCopy')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type +'/edit/' + item.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(type)"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row"><a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a></span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat((item.price ? item.price.price : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.price.NetPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.NetPrice : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a
            v-if="item.doc_header"
            @click="openComponent('accountingPrint', item.doc_head_id)"
          >
            {{ item.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.customer.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.customer_id)"
            >
              {{ (item.customer ? item.customer.name : '') }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.customer"
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.customer.fin_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('turnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.payed.amount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.amount : 0)) }} {{ item.currency.symbol }}
          <v-chip
            v-if="item.payed"
            class="mx-0"
            :color="(parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? 'red' : 'green')"
            small
            outlined
          >
            {{ (parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.price.price)-parseFloat(item.payed.amount)) : $t('payed')) }}
          </v-chip>
        </template>
        <template v-slot:item.payed.paymentsAmount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.paymentsAmount : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.payed.checksAmount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.checksAmount : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon
            v-if="item.pre_invoice == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat((item.tax ? item.tax : 0)) }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat((item.discount ? item.discount : 0)) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.number="{ item }">
          <a @click="edit(item)">
            {{ item.number }} {{ (item.official_number ? '(' + item.official_number + ')' : '') }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.content="{ item }">
          {{ (item.content ? item.content : '') }}
          <div class="pt-1">
            <v-chip
              v-for="(integrate, index) in item.integrator"
              :key="index"
              color="green"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ $t('registerBy') }} : {{ $t(integrate.key) }}  | {{ $t('id') }} : {{ integrate.value }}
                {{ (integrate.number ? ' | ' + $t('number') + ':' + integrate.number : '' ) }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.entrepot.id="{ item }">
          <v-btn
            v-if="item.entrepot"
            :loading="loading"
            class="ma-0 pa-1"
            :color="(item.entrepot.type === 'remittance' ? 'pink' : (item.entrepot.type === 'receipt' ? 'teal' : 'blue'))"
            plain
            small
            @click="entrepot_(item.entrepot)"
          >
            {{ $t(item.entrepot.type) }} {{ $t('entrepot') }} {{ item.entrepot.entrepot.name }} : {{ item.entrepot.id }}
          </v-btn>
        </template>
        <template v-slot:item.plan="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.plan"
              color="primary"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ (item.plan ? item.plan.plan.name : '') }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ (item.last_status ? item.last_status.status.name : '') }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.commission="{ item }">
          {{ (item.commission ? $numberFormat(item.commission.amount) : 0) }}
        </template>
        <template v-slot:item.returnCommission="{ item }">
          {{ (item.returnSell && item.returnSell.return_commission ? $numberFormat(item.returnSell.return_commission.amount) : 0) }}
        </template>
        <template v-slot:item.returnBackFromCustomer="{ item }">
          {{ (item.returnSell && item.returnSell.return_back_from_customer ? $numberFormat(item.returnSell.return_back_from_customer.amount) : 0) }}
        </template>
        <template v-slot:item.penaltyCancelling="{ item }">
          {{ (item.returnSell && item.returnSell.penalty_cancelling ? $numberFormat(item.returnSell.penalty_cancelling.amount) : 0) }}
        </template>
        <template v-slot:item.durabilityInEntrepot="{ item }">
          {{ (item.durabilityInEntrepot ? $numberFormat(item.durabilityInEntrepot.amount) : 0) }}
        </template>
        <template v-slot:item.processing="{ item }">
          {{ (item.processing ? $numberFormat(item.processing.amount) : 0) }}
        </template>
        <template v-slot:item.returnProcessing="{ item }">
          {{ (item.returnSell && item.returnSell.return_processing ? $numberFormat(item.returnSell.return_processing.amount) : 0) }}
        </template>
        <template v-slot:item.shipping="{ item }">
          {{ (item.shipping ? $numberFormat(item.shipping.amount) : 0) }}
        </template>
        <template v-slot:item.returnShipping="{ item }">
          {{ (item.returnSell && item.returnSell.return_shipping ? $numberFormat(item.returnSell.return_shipping.amount) : 0) }}
        </template>
        <template v-slot:item.returnSell="{ item }">
          {{ (item.returnSell && item.returnSell.price ? $numberFormat(item.returnSell.price.NetPrice) : 0) }}
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length) - 14 + (type !== 'sell' ? 1 : 0)}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('sumNetAmount') + ':' : '') }} {{ $numberFormat(totals.sumNetAmount) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('discount') + ':' : '') }} {{ $numberFormat(totals.discount) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('tax') +':': '') }}  {{ $numberFormat(totals.tax) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('price') + ':' : '') }} {{ $numberFormat(totals.price) }}
            </td>
            <td
              v-if="!isMobile"
              :colspan="`${isMobile?6:5}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t(integratType + 'Orders'))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="($store.state.permissions && $store.state.permissions.includes(type)) ? $t('new') : ''"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t(integratType + 'Orders'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="invoicePrintDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="invoicePrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint
            :id-prop="printId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="account"
              :title="$t('customer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="digikalaOrder"
            :get-item="uploadDialog"
            :digikala-prop="true"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import Invoicprint from './print'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'InvoiceList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Upload,
      Invoicprint,
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId', 'typeProp', 'accountProp'],
    data: () => ({
      excelItems: [],
      selected: [],
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      uploadDialog: false,
      digikalaPanel: null,
      integratType: null,
      dialogData: null,
      entrepot: null,
      category: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      showSelect: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      page: 1,
      pageCount: 1,
      headersMap: null,
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.sumNetAmount += (d.price ? parseFloat(d.price.price) + parseFloat(d.discount) - parseFloat(d.tax) : 0)
          acc.price += (d.price ? parseFloat(d.price.price) : 0)
          acc.discount += parseFloat(d.discount)
          acc.tax += parseFloat(d.tax)
          return acc
        }, {
          sumNetAmount: 0,
          price: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        app.page = 1
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      accountProp (val) {
        this.getItems()
      },
    },
    activated () {
    // this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'digikalaOrderList') {
        this.type = 'sell'
        this.integratType = 'digikala'
      }
      if (this.typeProp) {
        this.type = this.typeProp
      }
      this.headers = [
        {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'invoice_header.id',
          width: 50,
        },
        {
          text: this.$t('number'),
          sortable: true,
          value: 'number',
          table: 'invoice_header.id',
          width: 50,
        },
        {
          text: this.$t('number') + ' ' + this.$t('document'),
          sortable: false,
          value: 'doc_header.number',
          width: 50,
        },
        {
          text: this.$t('detailsName'),
          sortable: false,
          value: 'customer.name',
          width: 50,
        },
        {
          text: this.$t('date'),
          sortable: true,
          value: 'date',
          table: 'invoice_header.date',
          width: 50,
        },
        {
          text: this.$t('sellAmount'),
          sortable: false,
          value: 'price.NetPrice',
          width: 100,
        },
        {
          text: this.$t('returnSellAmount'),
          sortable: false,
          value: 'returnSell',
          width: 100,
        },
        {
          text: this.$t('commission'),
          sortable: false,
          value: 'commission',
          width: 100,
        },
        {
          text: this.$t('returnCommission'),
          sortable: false,
          value: 'returnCommission',
          width: 100,
        },
        {
          text: this.$t('returnBackFromCustomer'),
          sortable: false,
          value: 'returnBackFromCustomer',
          width: 100,
        },
        {
          text: this.$t('penaltyCancelling'),
          sortable: false,
          value: 'penaltyCancelling',
          width: 100,
        },
        {
          text: this.$t('durabilityInEntrepot'),
          sortable: false,
          value: 'durabilityInEntrepot',
          width: 100,
        },
        {
          text: this.$t('processingCost'),
          sortable: false,
          value: 'processing',
          width: 100,
        },
        {
          text: this.$t('returnProcessing'),
          sortable: false,
          value: 'returnProcessing',
          width: 100,
        },
        {
          text: this.$t('shipping'),
          sortable: false,
          value: 'shipping',
          width: 100,
        },
        {
          text: this.$t('returnShipping'),
          sortable: false,
          value: 'returnShipping',
          width: 100,
        },
        {
          text: this.$t('finalAmount'),
          sortable: false,
          value: 'price.price',
          width: 100,
        },
        {
          text: this.$t('entrepot'),
          sortable: true,
          value: 'entrepot.id',
          width: 100,
        },
        {
          text: this.$t('branch'),
          sortable: true,
          value: 'branch.name',
          width: 100,
        },
        {
          text: this.$t('status'),
          sortable: true,
          value: 'last_status.status_id',
          table: 'doc_header.buyer_id',
          width: 50,
        },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'tags',
          width: 100,
        },
        {
          text: this.$t('content'),
          sortable: true,
          value: 'content',
          table: 'products.description',
          width: 150,
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
    },
    methods: {
      openUploadDialog (item) {
        if (this.$root) {
          this.$root.$emit('open-user-file-process', { type: 'digikalaOrder' })
        }
      },
      copyInvoice (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice/' + item.uid + '/edit', {
          params: {
            id: item.uid,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: app.type, params: { itemsProp: res.article } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      entrepot_ (item) {
        this.$router.push({ name: item.type + 'Edit', params: { id: item.id } })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: this.type + 'Edit', params: { id: item.uid, tabName: item.number } })
      },
      editCategory (item) {
        this.$router.push({ name: 'invoiceCasherEdit', params: { id: item.uid, tabName: item.number } })
      },
      print (item) {
        this.$router.push({ name: 'invoicePrint', params: { id: item.uid, tabName: item.number } })
      // this.printId = item.uid
      // this.invoicePrintDialog = true
      },
      fishPrint (item) {
        this.$router.push({ name: 'invoiceRollprint', params: { id: item.uid, tabName: item.number } })
      },
      entrepotPrint (item) {
        this.$router.push({ name: item.entrepot.type + 'Print', params: { id: item.entrepot.id } })
      },
      getItems () {
        var app = this
        app.filter = false
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            search: app.search,
            accountProp: (app.accountProp ? app.accountProp.id : null),
            account: app.account,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromAmount: app.fromAmount,
            category: app.category,
            toAmount: app.toAmount,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            currency: app.currencyFilter,
            entrepot: app.entrepot,
            branch: app.branch,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            integratType: app.integratType,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      invoiceSms (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            invoiceSMS: 'active',
            id: item.id,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('sent')
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            id: d.id,
            type: app.$t(d.type),
            number: d.number,
            customer: (d.customer ? d.customer.name : null),
            date: d.date,
            price: app.$numberFormat((d.price ? d.price.price : 0)),
            discount: app.$numberFormat(d.discount),
            tax: app.$numberFormat(d.tax),
            warehouse: (d.entrepot ? d.entrepot.entrepot.name : ''),
            payment: (d.payed ? app.$numberFormat(d.payed.amount) : ''),
            integrator: (d.integrator && d.integrator.length > 0 ? app.$t(d.integrator[0].key) + ' = ' + d.integrator[0].value + ' | ' + d.integrator[0].number : ''),
            user: (d.user ? d.user.name : ''),
          })
        })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";


</style>
